export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* subtle background accents */}
      <div className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-redAccent/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 -left-24 h-72 w-72 rounded-full bg-black/5 blur-3xl" />

      <div className="mx-auto max-w-6xl px-4 py-16 md:py-24">
        <div className="grid gap-10 md:grid-cols-2 md:items-center">
          <div>
            <div className="inline-flex max-w-full items-center gap-2 rounded-full border border-black/10 bg-white px-2 py-1.5 text-[10px] text-black/70 shadow-sm min-[430px]:px-4 min-[430px]:py-2 min-[430px]:text-xs">
              <span className="h-2 w-2 shrink-0 rounded-full bg-redAccent" />
              <span className="whitespace-normal leading-tight min-[430px]:whitespace-nowrap">
                Licensed Security • Hospitality • Events • Retail • Protection
              </span>
            </div>

            <h1 className="mt-5 text-4xl md:text-5xl font-semibold tracking-tight">
              Professional security services built for{" "}
              <span className="text-redAccent">high pressure</span>{" "}
              environments.
            </h1>

            <p className="mt-5 text-black/70 leading-relaxed">
              From door supervision and event security to mobile response, CCTV
              operations, and close protection, our teams deliver calm,
              compliant, and proactive coverage across leisure, hospitality,
              retail and private clients.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                className="inline-flex justify-center rounded-xl bg-ink text-white px-6 py-3 text-sm font-medium hover:opacity-90 transition"
              >
                Request a Quote
              </a>
              <a
                href="#services"
                className="inline-flex justify-center rounded-xl border border-black/15 bg-white px-6 py-3 text-sm font-medium text-black hover:border-black/30 transition"
              >
                View Services
              </a>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
              <div className="rounded-2xl border border-black/10 bg-white p-4 shadow-sm">
                <div className="text-sm font-semibold">SIA ready</div>
                <div className="text-xs text-black/60 mt-1">
                  Professional staff
                </div>
              </div>
              <div className="rounded-2xl border border-black/10 bg-white p-4 shadow-sm">
                <div className="text-sm font-semibold">Fast cover</div>
                <div className="text-xs text-black/60 mt-1">
                  Short notice support
                </div>
              </div>
              <div className="rounded-2xl border border-black/10 bg-white p-4 shadow-sm">
                <div className="text-sm font-semibold">Trusted</div>
                <div className="text-xs text-black/60 mt-1">
                  Clear reporting
                </div>
              </div>
            </div>
          </div>

          {/* right-side "card" */}
          <div className="md:justify-self-end">
            <div className="rounded-3xl border border-black/10 bg-white shadow-soft overflow-hidden">
              <div className="bg-ink px-6 py-5 text-white">
                <div className="text-sm text-white/70">Coverage Overview</div>
                <div className="text-xl font-semibold mt-1">
                  Visible deterrence. Rapid response. Quiet professionalism.
                </div>
              </div>

              <div className="p-6 space-y-4">
                {[
                  {
                    title: "Door Supervision",
                    desc: "Queue control, conflict management, venue safety.",
                  },
                  {
                    title: "Mobile Response",
                    desc: "Scheduled checks, alarm activations, site patrols.",
                  },
                  {
                    title: "CCTV Operatives",
                    desc: "Monitoring, incident logging, evidence handling.",
                  },
                  {
                    title: "Close Protection",
                    desc: "Discreet protection for high-profile individuals.",
                  },
                ].map((x) => (
                  <div key={x.title} className="flex gap-3">
                    <div className="mt-1 h-2.5 w-2.5 rounded-full bg-redAccent" />
                    <div>
                      <div className="font-medium">{x.title}</div>
                      <div className="text-sm text-black/65">{x.desc}</div>
                    </div>
                  </div>
                ))}

                <div className="pt-2">
                  <a
                    href="#contact"
                    className="inline-flex w-full justify-center rounded-xl bg-redAccent text-white px-5 py-3 text-sm font-medium hover:opacity-90 transition"
                  >
                    Talk to Us Today
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
